import React from "react";
import { Button, BorderButton } from "../styles";
import trash from "../../../static/trash.svg";

const BorderBtn = ({
  _toggleVisibility,
  deleteVisible,
  sendPdf,
  collaborate,
  style,
  id
}) => {

  return (
    <BorderButton style={style} id={id}>
      <Button
        black={true}
        onClick={e => _toggleVisibility(e, collaborate, "collaborate")}
        style={{ marginLeft: "0" }}
      >
        Collaborate
      </Button>
      <Button onClick={e => _toggleVisibility(e, sendPdf, "sendPdf")}>Save</Button>
      <Button
        black={true}
        onClick={e => _toggleVisibility(e, deleteVisible, "delete")}
        className="trash"
      >
        <img src={trash}  alt='trash'/>
      </Button>
    </BorderButton>
  );
};
export default BorderBtn;
